import React, {useState, useEffect} from 'react'
import {sliderImg as slider} from '../utils/links'
import {IoIosArrowDropleftCircle, IoIosArrowDroprightCircle} from 'react-icons/io'

function Slider({imgArray}) {
    const [slide, setSlide] = useState(0);

    const sliderImg = imgArray ? imgArray : slider;

    const nextSlide = ()=> {
        slide < sliderImg.length-1 ? setSlide(old=>old+1) : setSlide(0);
    }

    const prevSlide = ()=> {
        slide <= 0 ? setSlide(sliderImg.length -1) : setSlide(old=>old-1);
    }

    useEffect(() => {
        const timer = setTimeout(nextSlide, 8000);
        return () => {
            clearTimeout(timer);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slide])

    return (
        <div className="slider-container">
            
            {
                sliderImg.map((el, index, array)=>{
                    if(index===slide){
                        return <Slide key={el.id} classes={"active"} {...el}/>
                    }else if(index + 1 === slide || (slide === 0 && index === array.length-1)){
                        return <Slide key={el.id} classes={"prev"} {...el}/>
                    }else{
                        return <Slide key={el.id} classes={"next"} {...el}/>
                    }
                })
            }
            <button onClick={prevSlide} className="slider-button slider-prev"><IoIosArrowDropleftCircle className="button-icon"/></button>
            <button onClick={nextSlide} className="slider-button slider-next"><IoIosArrowDroprightCircle className="button-icon"/></button>
        </div>
    )
}

function Slide({url, text, classes}) {
    return (
        <div style={
            {
            background: `url(${url})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            }}
        className={"slide " + classes}>
            <div className="slider-text">
                <p className="card-text">
                    {text}
                </p>
            </div>
        </div>
    )
}


export default Slider
